<template>
  <section class="about-receiving-kinds">
    <div class="about-receiving-kinds__content">
      <AboutPageHeadline
        class="about-receiving-kinds__headline"
        title="ギフトの受け取り方法"
      />
      <div class="about-receiving-kinds__receiving-kinds">
        <div class="about-receiving-kinds__receiving-kind">
          <div class="about-receiving-kinds__receiving-kind-content">
            <div
              class="about-receiving-kinds__receiving-kind-content-description"
            >
              <h3 class="about-receiving-kinds__receiving-kind-content-title">
                お店で利用する
              </h3>
              <p class="about-receiving-kinds__receiving-kind-content-text">
                <span>お店で会計する時に</span>
                <span>チケットを提示すると利用できます</span>
              </p>
              <ImgLazy
                :image-url="PickUpImg"
                alt-text=""
                aspect-ratio="172 / 107"
                image-class="about-receiving-kinds__receiving-kind-content-image"
              />
              <AboutPageSeeMoreButton
                text="ギフトを見る"
                href="/items?item_receiving_kinds%5B%5D=1"
                class="about-receiving-kinds__see-more--pc"
              />
            </div>
            <div class="about-receiving-kinds__receiving-kind-content__items">
              <div class="about-receiving-kinds__receiving-kind-content__item">
                <a href="/items/1370">
                  <ImgLazy
                    :image-url="PickUpItemImg1370"
                    alt-text="TULLY'S COFFEE タリーズデジタルギフト 商品画像"
                    aspect-ratio="1 / 1"
                  />
                </a>
              </div>
              <div class="about-receiving-kinds__receiving-kind-content__item">
                <a href="/items/966">
                  <ImgLazy
                    :image-url="PickUpItemImg966"
                    alt-text="サンマルクカフェ カフェチケット 商品画像"
                    aspect-ratio="1 / 1"
                  />
                </a>
              </div>
              <div
                class="about-receiving-kinds__receiving-kind-content__item about-receiving-kinds__receiving-kind-content__item--show-only-pc"
              >
                <a href="/items/996">
                  <ImgLazy
                    :image-url="PickUpItemImg996"
                    alt-text="大戸屋ごはん処 大戸屋ギフト券 商品画像"
                    aspect-ratio="1 / 1"
                  />
                </a>
              </div>
              <div class="about-receiving-kinds__receiving-kind-content__item">
                <a href="/items/666">
                  <ImgLazy
                    :image-url="PickUpItemImg666"
                    alt-text="日比谷花壇 フラワーギフトチケット"
                    aspect-ratio="1 / 1"
                  />
                </a>
              </div>
              <div class="about-receiving-kinds__receiving-kind-content__item">
                <a href="/items/1064">
                  <ImgLazy
                    :image-url="PickUpItemImg1064"
                    alt-text="LAWSON 【お持ち帰り限定】7種の対象ハーゲンダッツ（税込351円）いずれか1つ 商品画像"
                    aspect-ratio="1 / 1"
                  />
                </a>
              </div>
              <div class="about-receiving-kinds__receiving-kind-content__item">
                <a href="/items/1007">
                  <ImgLazy
                    :image-url="PickUpItemImg1007"
                    alt-text="てもみん・グローバル治療院 てもみんリラクゼーションチケット 商品画像"
                    aspect-ratio="1 / 1"
                  />
                </a>
              </div>
              <div class="about-receiving-kinds__receiving-kind-content__item">
                <a href="/items/1092">
                  <ImgLazy
                    :image-url="PickUpItemImg1092"
                    alt-text="イオンシネマ 映画鑑賞券【ポップコーンSサイズ＋ドリンクSサイズ】付き 商品画像"
                    aspect-ratio="1 / 1"
                  />
                </a>
              </div>
              <div
                class="about-receiving-kinds__receiving-kind-content__item about-receiving-kinds__receiving-kind-content__item--show-only-pc"
              >
                <a href="/items/2136">
                  <ImgLazy
                    :image-url="PickUpItemImg2136"
                    alt-text="Tabio（靴下屋） Tabio eGiftチケット 商品画像"
                    aspect-ratio="1 / 1"
                  />
                </a>
              </div>
            </div>
            <AboutPageSeeMoreButton
              text="ギフトを見る"
              href="/items?item_receiving_kinds%5B%5D=1"
              class="about-receiving-kinds__see-more--not-pc"
            />
          </div>
        </div>
        <div class="about-receiving-kinds__receiving-kind">
          <div class="about-receiving-kinds__receiving-kind-content">
            <div
              class="about-receiving-kinds__receiving-kind-content-description"
            >
              <h3 class="about-receiving-kinds__receiving-kind-content-title">
                オンラインで利用する
              </h3>
              <p class="about-receiving-kinds__receiving-kind-content-text">
                <span>Webサービスにシリアルコードなどを</span>
                <span>入力すると利用できます</span>
              </p>
              <ImgLazy
                :image-url="ExternalSiteUseImg"
                alt-text=""
                aspect-ratio="172 / 107"
                image-class="about-receiving-kinds__receiving-kind-content-image"
              />
              <AboutPageSeeMoreButton
                text="ギフトを見る"
                href="/items?item_receiving_kinds%5B%5D=2"
                class="about-receiving-kinds__see-more--pc"
              />
            </div>
            <div class="about-receiving-kinds__receiving-kind-content__items">
              <div class="about-receiving-kinds__receiving-kind-content__item">
                <a href="/items/746">
                  <ImgLazy
                    :image-url="ExternalSiteUseItemImg746"
                    alt-text="Hulu Huluチケット 商品画像"
                    aspect-ratio="1 / 1"
                  />
                </a>
              </div>
              <div class="about-receiving-kinds__receiving-kind-content__item">
                <a href="/items/4987">
                  <ImgLazy
                    :image-url="ExternalSiteUseItemImg4987"
                    alt-text="Meta Meta Quest デジタルギフトカード 商品画像"
                    aspect-ratio="1 / 1"
                  />
                </a>
              </div>
              <div class="about-receiving-kinds__receiving-kind-content__item">
                <a href="/brands/1084">
                  <ImgLazy
                    :image-url="ExternalSiteUseItemImg4386"
                    alt-text="IDOL CHAMP CHAMSIMチケット IDOL CHAMP（アイドルチャンプ） CHAMSIMクーポン 商品画像"
                    aspect-ratio="1 / 1"
                  />
                </a>
              </div>
              <div class="about-receiving-kinds__receiving-kind-content__item">
                <a href="/items/3069">
                  <ImgLazy
                    :image-url="ExternalSiteUseItemImg3069"
                    alt-text="漫画全巻ドットコム ギフトコード 商品画像"
                    aspect-ratio="1 / 1"
                  />
                </a>
              </div>
              <div class="about-receiving-kinds__receiving-kind-content__item">
                <a href="/items/3807">
                  <ImgLazy
                    :image-url="ExternalSiteUseItemImg3807"
                    alt-text="Leminoプレミアム Leminoプレミアムギフトコード 商品画像"
                    aspect-ratio="1 / 1"
                  />
                </a>
              </div>
              <div
                class="about-receiving-kinds__receiving-kind-content__item about-receiving-kinds__receiving-kind-content__item--show-only-pc"
              >
                <a href="/items/1189">
                  <ImgLazy
                    :image-url="ExternalSiteUseItemImg1189"
                    alt-text="DAZN DAZNギフトコード 商品画像"
                    aspect-ratio="1 / 1"
                  />
                </a>
              </div>
              <div class="about-receiving-kinds__receiving-kind-content__item">
                <a href="/items/3932">
                  <!-- eslint-disable no-irregular-whitespace -->
                  <ImgLazy
                    :image-url="ExternalSiteUseItemImg3932"
                    alt-text="産前産後ケアギフト券【オンライン相談まごころギフト】 商品画像"
                    aspect-ratio="1 / 1"
                  />
                  <!-- eslint-enable no-irregular-whitespace -->
                </a>
              </div>
              <div
                class="about-receiving-kinds__receiving-kind-content__item about-receiving-kinds__receiving-kind-content__item--show-only-pc"
              >
                <a href="/items/693">
                  <ImgLazy
                    :image-url="ExternalSiteUseItemImg693"
                    alt-text="レコチョク レコチョク プリペイド 商品画像"
                    aspect-ratio="1 / 1"
                  />
                </a>
              </div>
            </div>
            <AboutPageSeeMoreButton
              text="ギフトを見る"
              href="/items?item_receiving_kinds%5B%5D=2"
              class="about-receiving-kinds__see-more--not-pc"
            />
          </div>
        </div>
        <div class="about-receiving-kinds__receiving-kind">
          <div class="about-receiving-kinds__receiving-kind-content">
            <div
              class="about-receiving-kinds__receiving-kind-content-description"
            >
              <h3 class="about-receiving-kinds__receiving-kind-content-title">
                配送で受け取る
              </h3>
              <p class="about-receiving-kinds__receiving-kind-content-text">
                <span>受け取った人が届け先の住所を入力すると</span>
                <span>配送されます</span>
              </p>
              <ImgLazy
                :image-url="DeliveryImg"
                alt-text=""
                aspect-ratio="172 / 107"
                image-class="about-receiving-kinds__receiving-kind-content-image"
              />
              <AboutPageSeeMoreButton
                text="ギフトを見る"
                href="/items?item_receiving_kinds%5B%5D=3"
                class="about-receiving-kinds__see-more--pc"
              />
            </div>
            <div class="about-receiving-kinds__receiving-kind-content__items">
              <div class="about-receiving-kinds__receiving-kind-content__item">
                <a href="/items/3330">
                  <!-- eslint-disable no-irregular-whitespace -->
                  <ImgLazy
                    :image-url="DeliveryItemImg3330"
                    alt-text="アップ･スウェル めぐりズム　蒸気でホットアイマスク　無香料　5枚セット【ポスト投函】 商品画像"
                    aspect-ratio="1 / 1"
                  />
                  <!-- eslint-enable no-irregular-whitespace -->
                </a>
              </div>
              <div class="about-receiving-kinds__receiving-kind-content__item">
                <a href="/items/3326">
                  <ImgLazy
                    :image-url="DeliveryItemImg3326"
                    alt-text="株式会社アデリー ホシフルーツ あまおうのクリームいちご大福 ｆｕｗａｒｕ 商品画像"
                    aspect-ratio="1 / 1"
                  />
                </a>
              </div>
              <div
                class="about-receiving-kinds__receiving-kind-content__item about-receiving-kinds__receiving-kind-content__item--show-only-pc"
              >
                <a href="/items/3485">
                  <ImgLazy
                    :image-url="DeliveryItemImg3485"
                    alt-text="shirokane sweets TOKYO 白金プラチナプリン 商品画像"
                    aspect-ratio="1 / 1"
                  />
                </a>
              </div>
              <div class="about-receiving-kinds__receiving-kind-content__item">
                <a href="/items/1143">
                  <ImgLazy
                    :image-url="DeliveryItemImg1143"
                    alt-text="マルホ酒店 常陸野ネスト3本セット(330ml) 商品画像"
                    aspect-ratio="1 / 1"
                  />
                </a>
              </div>
              <div class="about-receiving-kinds__receiving-kind-content__item">
                <a href="/items/5963">
                  <ImgLazy
                    :image-url="DeliveryItemImg5963"
                    alt-text="ヴィヨン プレーンバウムクーヘン 商品画像"
                    aspect-ratio="1 / 1"
                  />
                </a>
              </div>
              <div
                class="about-receiving-kinds__receiving-kind-content__item about-receiving-kinds__receiving-kind-content__item--show-only-pc"
              >
                <a href="/items/3181">
                  <ImgLazy
                    :image-url="DeliveryItemImg3181"
                    alt-text="AOYAMA GIFT SALON (アオヤマギフトサロン) ケンズカフェ東京 特撰ガトーショコラ 商品画像"
                    aspect-ratio="1 / 1"
                  />
                </a>
              </div>
              <div class="about-receiving-kinds__receiving-kind-content__item">
                <a href="/items/3936">
                  <ImgLazy
                    :image-url="DeliveryItemImg3936"
                    alt-text="株式会社サニーフーズ 国産黒毛和牛6種部位 商品画像"
                    aspect-ratio="1 / 1"
                  />
                </a>
              </div>
              <div class="about-receiving-kinds__receiving-kind-content__item">
                <a href="/items/4417">
                  <ImgLazy
                    :image-url="DeliveryItemImg4417"
                    alt-text="Chapon ぐっすりスヤァ〜と「睡眠の質」 2本セット 商品画像"
                    aspect-ratio="1 / 1"
                  />
                </a>
              </div>
            </div>
            <AboutPageSeeMoreButton
              text="ギフトを見る"
              href="/items?item_receiving_kinds%5B%5D=3"
              class="about-receiving-kinds__see-more--not-pc"
            />
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup>
import ImgLazy from '../../../atoms/images/ImgLazy.vue'
import AboutPageHeadline from '../../../atoms/headlines/AboutPageHeadline.vue'
import AboutPageSeeMoreButton from '../../../molecules/buttons/AboutPageSeeMoreButton.vue'
// PickupImgs
import PickUpImg from '../../../../../../images/abouts/receiving_kind/01_pick_up.png'
import PickUpItemImg1370 from '../../../../../../images/abouts/receiving_kind/items/pick_up/01_1370.jpg'
import PickUpItemImg966 from '../../../../../../images/abouts/receiving_kind/items/pick_up/02_966.jpg'
import PickUpItemImg996 from '../../../../../../images/abouts/receiving_kind/items/pick_up/03_996.jpg'
import PickUpItemImg666 from '../../../../../../images/abouts/receiving_kind/items/pick_up/04_666.jpg'
import PickUpItemImg1064 from '../../../../../../images/abouts/receiving_kind/items/pick_up/05_1064.jpg'
import PickUpItemImg1007 from '../../../../../../images/abouts/receiving_kind/items/pick_up/06_1007.jpg'
import PickUpItemImg1092 from '../../../../../../images/abouts/receiving_kind/items/pick_up/07_1092.jpg'
import PickUpItemImg2136 from '../../../../../../images/abouts/receiving_kind/items/pick_up/08_2136.png'
// ExternalSiteUseImgs
import ExternalSiteUseImg from '../../../../../../images/abouts/receiving_kind/02_external_site_use.png'
import ExternalSiteUseItemImg746 from '../../../../../../images/abouts/receiving_kind/items/external_site_use/01_746.jpg'
import ExternalSiteUseItemImg4987 from '../../../../../../images/abouts/receiving_kind/items/external_site_use/02_4987.png'
import ExternalSiteUseItemImg4386 from '../../../../../../images/abouts/receiving_kind/items/external_site_use/03_4386.png'
import ExternalSiteUseItemImg3069 from '../../../../../../images/abouts/receiving_kind/items/external_site_use/04_3069.jpg'
import ExternalSiteUseItemImg3807 from '../../../../../../images/abouts/receiving_kind/items/external_site_use/05_3807.png'
import ExternalSiteUseItemImg1189 from '../../../../../../images/abouts/receiving_kind/items/external_site_use/06_1189.jpg'
import ExternalSiteUseItemImg3932 from '../../../../../../images/abouts/receiving_kind/items/external_site_use/07_3932.png'
import ExternalSiteUseItemImg693 from '../../../../../../images/abouts/receiving_kind/items/external_site_use/08_693.jpg'
// DeliveryImgs
import DeliveryImg from '../../../../../../images/abouts/receiving_kind/03_delivery.png'
import DeliveryItemImg3330 from '../../../../../../images/abouts/receiving_kind/items/delivery/01_3330.jpg'
import DeliveryItemImg3326 from '../../../../../../images/abouts/receiving_kind/items/delivery/02_3326.jpg'
import DeliveryItemImg3485 from '../../../../../../images/abouts/receiving_kind/items/delivery/03_3485.jpg'
import DeliveryItemImg1143 from '../../../../../../images/abouts/receiving_kind/items/delivery/04_1143.jpg'
import DeliveryItemImg5963 from '../../../../../../images/abouts/receiving_kind/items/delivery/05_5963.jpg'
import DeliveryItemImg3181 from '../../../../../../images/abouts/receiving_kind/items/delivery/06_3181.jpg'
import DeliveryItemImg3936 from '../../../../../../images/abouts/receiving_kind/items/delivery/07_3936.jpg'
import DeliveryItemImg4417 from '../../../../../../images/abouts/receiving_kind/items/delivery/08_4417.png'
</script>

<style lang="scss" scoped>
.about-receiving-kinds {
  background-color: $primary-lighten;
  display: flex;
  justify-content: center;

  &__content {
    padding: 96px 72px;
    display: flex;
    flex-direction: column;
    gap: 48px;
    max-width: 1440px;
    width: 100%;

    @media all and (max-width: ($pc-width - 1)) {
      padding: 64px 24px;
      gap: 24px;
    }
  }

  &__receiving-kinds {
    display: flex;
    flex-direction: column;
    gap: 32px;

    @media all and (max-width: ($pc-width - 1)) {
      gap: 24px;
    }
  }

  &__receiving-kind {
    padding: 64px;
    display: flex;
    flex-direction: column;
    gap: 64px;
    background-color: $white;
    border-radius: 32px;

    @media all and (max-width: ($pc-width - 1)) {
      padding: 32px 24px;
    }
  }

  &__receiving-kind-content {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 64px;

    @media all and (max-width: ($pc-width - 1)) {
      flex-direction: column;
      gap: 16px;
    }

    &-description {
      max-width: 100%;
      min-width: 0;
      display: flex;
      flex-direction: column;
      gap: 16px;
    }

    ::v-deep &-image {
      max-width: 344px;

      @media all and (max-width: ($pc-width - 1)) {
        max-width: 279px;
      }
    }

    &-title {
      font-weight: bold;
      font-size: 1.8rem;
      line-height: 1.6;
      text-align: center;
    }

    &-text {
      font-size: 1.2rem;
      line-height: 1.6;

      > span {
        display: block;
      }
    }

    &__items {
      display: grid;
      grid-template-columns: repeat(4, 1fr);
      gap: 24px 16px;

      @media all and (max-width: ($pc-width - 1)) {
        grid-template-columns: repeat(6, 1fr);
        gap: 8px;
      }

      @media all and (max-width: ($base-contents-width - 1)) {
        grid-template-columns: repeat(3, 1fr);
      }
    }

    &__item {
      width: 100%;
      max-width: 198px;
      overflow: hidden;
      box-sizing: border-box;

      a {
        font-size: 0;
      }

      img {
        @extend %hover-common;
        width: 100%;
        border-radius: 8px;
        display: block;
      }

      @media all and (max-width: ($pc-width - 1)) {
        &--show-only-pc {
          display: none;
        }
      }
    }
  }

  &__see-more {
    &--pc {
      display: flex;

      @media all and (max-width: ($pc-width - 1)) {
        display: none;
      }
    }

    &--not-pc {
      display: none;

      @media all and (max-width: ($pc-width - 1)) {
        display: flex;
        width: 100%;
      }
    }
  }
}
</style>
